import actions from './actions'
import mutations from './mutations'
import getters from './getters'

let state = {
  selectedCountry: null,
  partners: [],
  events: []
};

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations
}


// WEBPACK FOOTER //
// ./src/store/countries/index.js